__turbopack_context__.v({
  "chevron": "Accordion-module__fs9tPW__chevron",
  "header": "Accordion-module__fs9tPW__header",
  "headerOpen": "Accordion-module__fs9tPW__headerOpen",
  "item": "Accordion-module__fs9tPW__item",
  "panel": "Accordion-module__fs9tPW__panel",
  "title": "Accordion-module__fs9tPW__title",
  "wrapper": "Accordion-module__fs9tPW__wrapper",
});
